import { useContext } from 'react';
import { RatingContext } from 'contexts/rating_context';

const useRating = () => {
    return useContext(RatingContext);
};

export default useRating;
